import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 700px;
  height: calc(100vh - 400px);
  & input, textarea {
    font-size: 14px !important;
  }
  & > div + div {
    margin-top: .5rem;
  }
`;

export const VarTip = styled.span`
  color: ${({ theme }) => theme.color};
  font-size: 14px;
  margin-bottom: 0.5rem;
`;

export const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  & .select-wrapper {
    max-width: 50px;
  }
  & > * {
    margin-right: 1rem;
    &:last-child {
      margin-right: 0;
    }
  }
  & .code-textarea {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme.inputBottomLine};
    border-radius: 5px;
  }
  & .extra-label {
    color: ${({ theme }) => theme.inputLabel};
    margin-left: auto;
  }
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px;
  background-color: ${({ theme }) => theme.container};
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.containerHover};
  justify-content: center;
  align-items: center;
  max-width: 100%;
    
  & svg {
    margin-right: 5px;
    height: 20px;
    fill: ${({ theme }) => theme.primary};
  }
`;

export const NoFile = styled.span`
  color: ${({ theme }) => theme.inputLabel};
  font-style: italic;
`;
